// ------------------- REGISTER PROGRESS --------------

export const NOTI_AUTO_HIDE_TIME = 10000
